import { useCallback, useEffect, useState } from "react";
import {
  MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle,
  MDBModalBody, MDBModalFooter, MDBBtn, MDBInput
} from "mdb-react-ui-kit";

import { toast } from "Projects/CC_cubi_clan_project/GlobalComponents/ToastHost/ToastHost";
import { joinGame, isOk } from "Projects/CHAMP_championsjourney_project/Utils/ChampService";

export default function JoinGameModal({ show, setShow, onJoined }) {
  const [codigo, setCodigo] = useState("");
  const [nombrePersonaje, setNombrePersonaje] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (show) {
      setCodigo("");
      setNombrePersonaje("");
    }
  }, [show]);

  const handleClose = useCallback(() => setShow(false), [setShow]);

  async function handleSave() {
    if (!codigo.trim()) {
      toast.show({ message: "Introduce el código de la partida", type: "warning" });
      return;
    }
    setSaving(true);
    try {
      const res = await joinGame({
        codigo: codigo.trim().toUpperCase(),
        nombrePersonaje: nombrePersonaje.trim() || null,
      });
      if (isOk(res)) {
        toast.show({ message: "Te has unido a la partida", type: "success" });
        setShow(false);
        onJoined && onJoined(res.DATA);
      } else {
        toast.show({ message: res?.MESSAGE || "No se pudo unir a la partida", type: "danger" });
      }
    } finally {
      setSaving(false);
    }
  }

  return (
    <MDBModal show={show} onHide={handleClose} tabIndex="-1">
      <MDBModalDialog>
        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>Unirse a una partida</MDBModalTitle>
            <MDBBtn className="btn-close" color="none" onClick={handleClose} />
          </MDBModalHeader>
          <MDBModalBody>
            <MDBInput
              label="Código de partida"
              value={codigo}
              onChange={(e) => setCodigo(e.target.value.toUpperCase())}
              className="mb-3"
              maxLength={6}
            />
            <MDBInput
              label="Nombre de tu personaje (opcional)"
              value={nombrePersonaje}
              onChange={(e) => setNombrePersonaje(e.target.value)}
            />
          </MDBModalBody>
          <MDBModalFooter>
            <MDBBtn color="secondary" onClick={handleClose} disabled={saving}>Cancelar</MDBBtn>
            <MDBBtn className="champ-btn-secondary" onClick={handleSave} disabled={saving}>
              Unirse
            </MDBBtn>
          </MDBModalFooter>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  );
}
